import { View } from 'react-native';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Container = ({ children, className }: Props) => {
  return (
    <View className={twMerge(['px-4 md:px-6 xl:px-0', className])}>
      {children}
    </View>
  );
};

export default Container;
